import React from "react";
import { LdIcon } from "@emdgroup-liquid/liquid/dist/react";
import { Sidebar, Link } from "../../components";

import { useMediaQuery } from "hooks/useMediaQuery";
import { Breakpoint } from "util/screen";

const Navigation = () => {
  const [isMd] = useMediaQuery(Breakpoint.md);
  return (
    <Sidebar>
      <nav>
        <Link
          to="/surveys"
          data-test="sidebar-item-survey"
          label="My Surveys"
          icon={<LdIcon name="dashboard" />}
          isCollapsed={!isMd}
        />
        <Link
          to="/new"
          data-test="sidebar-item-create"
          label="Launch new"
          icon={<LdIcon name="rocket" />}
          isCollapsed={!isMd}
        />
      </nav>
    </Sidebar>
  );
};

export default Navigation;
